var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('SideBar',{on:{"locale-select":_vm.changeLocale,"page-select":_vm.changePage}}),_c('div',{attrs:{"id":"content"}},[_c('keep-alive',[_c(_vm.selectedComponent,{tag:"component"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }